
document.addEventListener("DOMContentLoaded", function () {
  // Initialize read more functionality
  const readMoreHandler = initReadMore();
  document.addEventListener("click", readMoreHandler);
  
  initBoostAppQuickView();
});

function initBoostAppQuickView() {
  let isModalOpen = false;
  let currentModal = null;

  function closeModal() {
    if (currentModal) {
      if (typeof currentModal.hide === 'function') {
        currentModal.hide();
      } else {
        currentModal.removeAttribute('open');
      }
      isModalOpen = false;
      currentModal = null;
    }
  }

  document.querySelectorAll('.boost-sd__button--select-option').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      openQuickViewModal(btn);
    });
  });

  document.addEventListener('click', e => {
    if (isModalOpen && currentModal && !currentModal.contains(e.target)) {
      closeModal();
    }
  });

  function openQuickViewModal(button) {
    try {
      const metadata = JSON.parse(button.getAttribute('data-metadata-product')?.trim());
      const productId = metadata?.action?.quickView?.productId;
      if (!productId) return;

      if (isModalOpen) closeModal();

      let modal = document.querySelector(`quick-view-modal#QuickView-${productId}`) ||
                  document.querySelector(`quick-view-modal[id*="${productId}"]`) ||
                  document.querySelector(`quick-view-modal[data-product-url*="${productId}"]`) ||
                  Array.from(document.querySelectorAll('quick-view-modal')).find(m => {
                    return (m.id || '').includes(productId) || (m.getAttribute('data-product-url') || '').includes(productId);
                  });

      if (!modal) {
        console.warn('Quick view modal not found for product ID:', productId);
        return;
      }

      currentModal = modal;
      isModalOpen = true;

      modal.querySelectorAll('[data-close-modal]').forEach(btn => btn.addEventListener('click', closeModal));

      if (typeof modal.show === 'function') {
        modal.show(button);
      } else {
        modal.setAttribute('open', '');
      }
    } catch (err) {
      console.error('Error opening quick view modal:', err);
    }
  }
}


function initReadMore() {
  // Initialize state for all existing elements
  const readMoreWrappers = document.querySelectorAll(".read-more-wrapper");
  readMoreWrappers.forEach((wrapper) => {
    const content = wrapper.querySelector(".read-more-content-container");
    const button = wrapper.querySelector(".read-more-btn");

    if (!content || !button) return;

    const textLength = content.textContent.trim().length;
    const maxChars = 250;

    // Check if text is longer than maxChars
    if (textLength > maxChars) {
      // Add collapsed class if not exists
      if (!content.classList.contains("collapsed")) {
        content.classList.add("collapsed");
      }

      // Show button
      button.style.display = "block";
    } else {
      // Remove collapsed and expanded classes
      content.classList.remove("collapsed", "expanded");

      // Hide button
      button.style.display = "none";
    }
  });

  // Return the event listener function
  return function (event) {
    const button = event.target.closest(".read-more-btn");
    if (!button) return;

    const wrapper = button.closest(".read-more-wrapper");
    const content = wrapper.querySelector(".read-more-content-container");
    if (!content) return;

    const textLength = content.textContent.trim().length;
    const maxChars = 250;

    // Only handle if text is longer than maxChars
    if (textLength > maxChars) {
      if (content.classList.contains("collapsed")) {
        content.classList.remove("collapsed");
        content.classList.add("expanded");
        button.textContent = "Read less";
      } else {
        content.classList.remove("expanded");
        content.classList.add("collapsed");
        button.textContent = "Read more";
      }
    }
  };
}
